<template>
<ThumbnailSlide  class="thumbnail" :slide="slides[0]" :ratio="slides[0].ratio" :size="width" />
    
</template>

<script lang="ts">
import { computed, defineComponent} from 'vue'
import { useStore } from '@/store'
import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
export default defineComponent({
  name: 'thumbnails',
  components: {
    ThumbnailSlide,
  },
  setup() {
    const store = useStore()
    const slides = computed(() => store.state.slides)
    const width = 400
    return {
      slides,
      width
    }
  },
})
</script>

<style lang="scss" scoped>
.thumbnails {
  display: flex;
  flex-direction: column;
  user-select: none;
  position: absolute;
  z-index: 1;
  left: -160px;
  top: 0;
  height: 100%;
  width: 160px;
  transition: left .4s;
}

.thumbnails.show {
  left: 59px;
}
.add-slide {
  height: 40px;
  font-size: 12px;
  display: flex;
  flex-shrink: 0;
  border-bottom: 1px solid $borderColor;
  cursor: pointer;

  .btn {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      background-color: $lightGray;
    }
  }
  .select-btn {
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid $borderColor;

    &:hover {
      background-color: $lightGray;
    }
  }

  .icon {
    margin-right: 3px;
    font-size: 14px;
  }
}
.thumbnail-list {
  padding: 0;
  flex: 1;
  overflow: auto;
}
.thumbnail-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  position: relative;
  .thumbnail {
    outline: 2px solid rgba($color: $themeColor, $alpha: .15);
  }

  &.active {
    .thumbnail {
      outline-color: $themeColor;
    }
  }
  &.selected {
    .thumbnail {
      outline-color: $themeColor;
    }
  }
  .active {
    background: #eef2f8;
  }
}
.label {
  font-size: 12px;
  color: #fff;
  width: 20px;
  cursor: grab;
  position: absolute;
  z-index: 1;
  bottom: 12px;
  right: 18px;
  background: rgb(0 0 0 / 68%);
  text-align: center;
  line-height: 18px;
  height: 20px;
  padding: 0 4px;
  &:active {
    cursor: grabbing;
  }
}
</style>